//Modules
import React from "react"
import { Link } from "gatsby"
//Styles
import styled from "styled-components"
import { spacing, font, flex } from "../../../Utilities"

const Logo = () => {
  return (
    <StyledLogoContainer>
      <Link to="/">
        <StyledCursiveLogo className="cursive-logo">Ms. Ty</StyledCursiveLogo>
      </Link>
    </StyledLogoContainer>
  )
}

const StyledLogoContainer = styled.div`
  ${flex("column", "center", "center")};
  height: 100%;
  margin-left: ${spacing.M};
  height: 100%;
`

const StyledCursiveLogo = styled.h1`
  ${font("XXL")};

  font-family: "Sacramento", cursive;
`

export default Logo
